import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const statusBadge = (s) => {
  const map = { present:'badge-green', absent:'badge-red', leave:'badge-blue', holiday:'badge-yellow', half_day:'badge-purple' };
  return <span className={`badge ${map[s]||'badge-gray'}`}>{s?.replace('_',' ')}</span>;
};

export default function MyAttendance() {
  const [records, setRecords] = useState([]);
  const [summary, setSummary] = useState(null);
  const [period, setPeriod]   = useState('month');
  const today = new Date().toISOString().split('T')[0];
  const monthStart = today.slice(0,7)+'-01';

  useEffect(() => { fetchData(); }, [period]);

  const fetchData = async () => {
    const from = period === 'month' ? monthStart : today.slice(0,4)+'-01-01';
    const [r, s] = await Promise.all([
      api.get(`/attendance/my?from=${from}&to=${today}`),
      api.get(`/attendance/summary?period=${period}`),
    ]);
    setRecords(r.data);
    setSummary(s.data);
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>My Attendance</h1>
        <select className="form-control" style={{width:140}} value={period} onChange={e=>setPeriod(e.target.value)}>
          <option value="month">This Month</option>
          <option value="ytd">This Year</option>
        </select>
      </div>

      {summary && (
        <div className="stat-grid">
          <div className="stat-card"><div className="stat-num">{summary.present_days||0}</div><div className="stat-label">Present Days</div></div>
          <div className="stat-card"><div className="stat-num">{summary.absent_days||0}</div><div className="stat-label">Absent Days</div></div>
          <div className="stat-card"><div className="stat-num">{parseFloat(summary.total_regular||0).toFixed(1)}</div><div className="stat-label">Regular Hours</div></div>
          <div className="stat-card"><div className="stat-num" style={{color:'var(--success)'}}>{parseFloat(summary.total_overtime||0).toFixed(1)}</div><div className="stat-label">Overtime Hours</div></div>
          <div className="stat-card"><div className="stat-num">{summary.wfh_days||0}</div><div className="stat-label">WFH Days</div></div>
        </div>
      )}

      <div className="card">
        <div className="card-title">Attendance History</div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Check In</th><th>Check Out</th><th>Regular Hrs</th><th>Overtime</th><th>WFH</th><th>Status</th></tr></thead>
            <tbody>
              {records.length === 0 && <tr><td colSpan="7" className="text-center text-muted" style={{padding:24}}>No records found</td></tr>}
              {records.map(r => (
                <tr key={r.id}>
                  <td>{new Date(r.date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</td>
                  <td>{r.check_in ? new Date(r.check_in).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                  <td>
                    {r.check_out ? new Date(r.check_out).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}
                    {r.auto_checkout && <span className="badge badge-yellow" style={{marginLeft:6,fontSize:10}}>Auto</span>}
                  </td>
                  <td>{r.regular_hours || 0}h</td>
                  <td>{r.overtime_hours > 0 ? <span style={{color:'var(--success)',fontWeight:600}}>+{r.overtime_hours}h</span> : '—'}</td>
                  <td>{r.is_wfh ? '🏡 Yes' : '—'}</td>
                  <td>{statusBadge(r.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
